import React from "react"
import Img from "gatsby-image"
import classnames from "classnames"

const FeaturePerson = ({ personFluidImage, personName }) => {
  return (
    <div className="feature-discription__person">
      <div className="feature-discription__person__img">
        <Img fluid={personFluidImage}></Img>
      </div>
      <div className="feature-discription__person__name">{personName}</div>
    </div>
  )
}

const FeatureDiscription = ({
  children,
  title,
  personName,
  personFluidImage,
  noPerson,
  isLangEN,
}) => {
  return (
    <div
      className={classnames({
        "feature-discription": true,
        "feature-discription--no-person": noPerson,
      })}
    >
      {!noPerson && (
        <FeaturePerson
          personFluidImage={personFluidImage}
          personName={personName}
        ></FeaturePerson>
      )}
      <h3 className="feature-discription__title">{title}</h3>
      <p
        className={classnames({
          "feature-discription__content": true,
          "feature-discription__content--no-person": noPerson,
          "feature-discription__content--en": isLangEN,
        })}
      >
        {children}
      </p>
    </div>
  )
}

export default FeatureDiscription
